import React from 'react';
import Snackbar from './Snackbar';
import { formatTime } from '../../functions/forms';


let timer;
class Session extends React.Component {


    constructor(props) {
        super(props);
        const now = new Date();
        if (sessionStorage.valid && Date.parse(sessionStorage.valid) < now) {
            props.logOutUser();
            window.location.reload();
        } else {
            sessionStorage.setItem('user', props.user);
            sessionStorage.setItem('token', props.token);
            this.checkExpiration(props);
        }
    }

    state = {
        offline: false
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.user && nextProps.user !== this.props.user) {
            this.checkExpiration(nextProps);
        } else if (!nextProps.user && timer) {
            clearInterval(timer);
        }
    }

    checkExpiration = (props) => {
        console.log(
            `Active: ${sessionStorage.valid} for ${props.user} 
            ${props.token} `,
        );
        if (props.user && sessionStorage.valid) {
            timer = setInterval(this.ping.bind(this), 180000);
            this.ping();
        } else {
            this.props.logOutUser();
        }
    };

    ping() {
        console.log(`check internal: ${sessionStorage.valid}`);
        this.props
            .keepSession()
            .then(() => {
                this.props.loadAlert(this.props.user);
            })
            .catch((error) => {
                const now = new Date();
                if (
                    error.message === '403' ||
                    (sessionStorage.valid && Date.parse(sessionStorage.valid) < now)
                ) {
                    this.props.logOutUser();
                    window.location.reload();
                } else {
                    this.setState({ offline: true });
                }
            });
    }


    handleClose = (event) => {
        this.setState({ offline: false });
    };

    render() {
        const { offline } = this.state;
        const { intl } = this.props;
        if (offline && sessionStorage.valid) {
            const d = new Date(new Date(Date.parse(sessionStorage.valid)) - new Date());
            return (
                <Snackbar
                    open={offline}
                    variant="warning"
                    text={`${intl.formatMessage({ id: 'offline' })} ${formatTime(d)}`}
                    onClose={this.handleClose}
                />
            );
        } else {
            return null;
        }

    }
}

export default Session;



// WEBPACK FOOTER //
// ./src/components/labels/Session.js